import React, { useEffect } from "react";
import { Row, Col } from "reactstrap";
import Select, { components } from "react-select";
import { getPropertyList } from "../TenantForm/Helpers/api";

const ALL_BUILDINGS = { value: "", label: "All buildings" };

// Light controls sitting on the dark hero band.
const heroSelectStyles = {
  menu: (base) => ({ ...base, zIndex: 9999, color: "#1f2a3d" }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    borderRadius: 8,
    backgroundColor: "#ffffff",
    borderColor: state.isFocused ? "#2563eb" : "#d7deea",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(37,99,235,0.35)" : "none",
    ":hover": { borderColor: "#2563eb" },
  }),
  singleValue: (base) => ({ ...base, color: "#1f2a3d" }),
  placeholder: (base) => ({ ...base, color: "#8794a8" }),
  input: (base) => ({ ...base, color: "#1f2a3d" }),
};

const WithBuildingIcon = (props) => (
  <components.Control {...props}>
    <i className="mdi mdi-office-building-outline ms-2 me-1" style={{ color: "#8794a8" }} />
    {props.children}
  </components.Control>
);

const DirectoryFilters = ({ userData, filterData, setFilterData }) => {
  useEffect(() => {
    if (!userData?.id) return;
    getPropertyList(userData).then((filtered) => {
      if (filtered) setFilterData((prev) => ({ ...prev, ...filtered }));
    });
  }, [userData?.id]);

  const propertyOptions = (filterData.propertyList || []).map((item) => ({
    id: item._id,
    value: item.title,
    label: `${item.title}, ${item.location}`,
    building: item.building || [],
  }));

  const buildingOptions = [
    ALL_BUILDINGS,
    ...(filterData.building_list || []).map((b) => ({
      value: b.buildingName,
      label: b.buildingName,
    })),
  ];

  const onProperty = (property) =>
    setFilterData((prev) => ({
      ...prev,
      property_id: property?.id || "",
      property_name: property?.value || "",
      building_list: property?.building || [],
      building_name: "",
    }));

  const onBuilding = (building) =>
    setFilterData((prev) => ({ ...prev, building_name: building?.value || "" }));

  return (
    <Row className="g-3">
      <Col md={5}>
        <label htmlFor="rd-property" className="rd-hero-label">
          Property
        </label>
        <Select
          inputId="rd-property"
          value={
            filterData.property_id
              ? { value: filterData.property_name, label: filterData.property_name }
              : null
          }
          options={propertyOptions}
          placeholder="Search by name"
          onChange={onProperty}
          styles={heroSelectStyles}
          menuPortalTarget={document.body}
          components={{ Control: WithBuildingIcon }}
        />
      </Col>

      {filterData.building_list?.length > 0 && (
        <Col md={4}>
          <label htmlFor="rd-building" className="rd-hero-label">
            Building (optional)
          </label>
          <Select
            inputId="rd-building"
            value={
              filterData.building_name
                ? { value: filterData.building_name, label: filterData.building_name }
                : ALL_BUILDINGS
            }
            options={buildingOptions}
            placeholder="All buildings"
            onChange={onBuilding}
            styles={heroSelectStyles}
            menuPortalTarget={document.body}
            components={{ Control: WithBuildingIcon }}
          />
        </Col>
      )}
    </Row>
  );
};

export { DirectoryFilters };
